import React, {useContext} from 'react';
import {UserContext} from '../../src/contexts/UserContext';
import {useSelector} from 'react-redux';
import {IReduxRootState} from '../../src/@interfaces';
import {INavigationItem} from '../../src/@interfaces/Navigation';
import {Navigate} from 'react-router-dom';
import {getRouteUri} from '../../src/helpers/getRouteUri';
import LoadingLayout from '../../src/components/_layouts/Loading/LoadingLayout';
import Error404 from '../errors/Error404';
import ViewRepresentation from '../../src/components/ViewRepresentation/ViewRepresentation';

const getDashboardsMenuItemsMap = (items: INavigationItem[]) => items.reduce<{
    admin?: INavigationItem,
    manager?: INavigationItem,
    production?: INavigationItem,
}>((res, item) => {
    if (!item.route || !item.route?.startsWith('dashboards@')) {
        return res;
    }

    const name = item.route.split('@')[1];
    if (['admin', 'manager', 'production'].includes(name)) {
        res[name as ('admin' | 'manager' | 'production')] = item;
    }

    return res;
}, {});

export default function DashboardResolver() {
    const userContext = useContext(UserContext);
    const dashboards = getDashboardsMenuItemsMap(
            useSelector((state: IReduxRootState) => state.navigation.sidebar)
    );

    if (!userContext) {
        return <LoadingLayout/>;
    }

    const process = (item: (typeof dashboards)[keyof typeof dashboards]) => {
        if (
                item &&
                item.route &&
                (!item.permissions || userContext.canAny(item.permissions))
        ) {
            return <Navigate to={getRouteUri(item.route)}/>;
        }

        return null;
    };

    return (
            process(dashboards.admin) ??
            process(dashboards.production) ??
            process(dashboards.manager) ??
            <ViewRepresentation element={Error404}/>
    );
}
